import { UILogicController } from "@view/root/__proto__/withController";
import { IScreenControllerLogin } from "@screens/LoginScreen/connector/__types__/UIViewController";
import { message } from "antd";
import { Utils } from "@modules/utils";
import { LoginViewModel } from "@viewModels/LoginViewModel/LoginViewModel";
import { ILoginViewModel } from "@viewModels/LoginViewModel/__types__/ILoginViewModel";
import { IRootTreeModel } from "domain/models";

class ScreenControllerLogin
  extends UILogicController
  implements IScreenControllerLogin
{
  private LoginViewModel: ILoginViewModel;

  public constructor(model: IRootTreeModel) {
    super(model);

    this.LoginViewModel = new LoginViewModel(model);
  }

  public get isRequestInProgress(): boolean {
    return this.LoginViewModel.statuses.isInProgress;
  }

  public login = async (user: {
    username: string;
    password: string;
  }): Promise<void> => {
    try {
      await this.LoginViewModel.authUser(user);
    } catch (error) {
      message.error(
        Utils.translateIfLanguageKey(Utils.getMessageFromError(error))
      );
    }
  };
}

export { ScreenControllerLogin };
